// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getWeekDay } from '@tectonics/prs/week-day';
import { usePendingIncomingPayment, getSafeDueDate } from '@tectonics/prs/incoming-payment';
import { RenderEfectivoNode, RenderEBankingNode } from './payment-option-components';
import { ButtonWrapper } from '../commons/render-helpers';
import { ShowBarcodePdfButton } from '../commons/show-barcode-pdf-button';
import { TextDisplay } from '../commons/text-display';
import { VoucherNumberBox } from '../commons/voucher/voucher-number-box';
import { Separator } from '../../../atoms';
import { DisplayDueDate } from '../../../organisms/display-due-date';
import { DisplayTotalAmount } from '../../../organisms/display-total-amount';
import { DashedHr, HeaderText, PaymentInfoWrapper } from '../../../organisms/shared-styled-components';
import { RenderPaymentInfoContainer } from '../../../organisms/payment-info-display';
import { VerticalAccordion } from '../../../organisms/vertical-accordion';

export function RenderTotalDueDateAndBarcodeNumber(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <PaymentInfoWrapper>
      <DisplayTotalAmount label="Valor a pagar" location="left" redesign={true} />
      <DisplayDueDate label="Fecha de Vencimento" sublabel={`Pagar hasta el ${getWeekDay(getSafeDueDate(incomingPayment), dueDateWeekDay)}`} redesign={true} />
      <VoucherNumberBox redesign={true}>
        <TextDisplay title="Número de Recaudación" value="get_pagosnet_barcode" />
        <BankingImage src="https://s3-us-west-1.amazonaws.com/cdn.ebanx.com/images/small/pagosnet-sm.png" alt="pagonet" />
      </VoucherNumberBox>
    </PaymentInfoWrapper>
  );
}

export function RenderButtonArea(): Node {
  return (
    <>
      <Separator direction="vertical" size={3} />
      <ButtonWrapper>
        <ShowBarcodePdfButton inverseStyle={false} format="pdf" buttonMessage="Guardar Número de recaudación en PDF"/>
      </ButtonWrapper>
      <ButtonWrapper>
        <ShowBarcodePdfButton inverseStyle={true} buttonMessage="Imprimir número de recaudación"/>
      </ButtonWrapper>
    </>
  );
}

export function RenderPaymentInstructions(): Node {
  return (
    <>
      <HeaderText>Instrucciones de pago</HeaderText>
      <div>Elegí tu mejor opción para pagar y seguí las instrucciones:</div>
      <Separator direction="vertical" size="4"/>
      <VerticalAccordion initial="efectivo" items={[
        { id: 'efectivo', title: 'Pago en efectivo', content: <RenderEfectivoNode /> },
        { id: 'ebanking', title: 'Pago vía Portales E-banking', content: <RenderEBankingNode /> },
      ]}/>

      <DashedHr />

      <RenderPaymentInfoContainer
        h1Text="¿Ya conoces la Central de Ayuda EBANX?"
        items={[
          {
            imgSrc: 'https://cdn.ebanx.com/images/vouchers/files-icon.svg',
            subText: 'Si tienes dudas adicionales acerca de tu pago, o tu reembolso visítanos en la Central de Ayuda EBANX:',
            strong:  'ayuda.ebanx.com/hc/es-419#/Bolivia',
          },
        ]}
      />
    </>
  );
}

const BankingImage = styled.img`
  max-width: 140px;
  src: ${props => props.src ? props.src : ''};
`;

const dueDateWeekDay = [
  'lunes',
  'lunes',
  'martes',
  'miércoles',
  'jueves',
  'viernes',
  'lunes',
];
